import React, { lazy } from 'react';

const AutopayEnrollmentComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "carvana-purchase-autopay-enrollment" */ '|/app/purchase/checkout/steps/autopay-enrollment'
    )
);

export const AutopayEnrollmentRoute = () => {
  return <AutopayEnrollmentComponent />;
};
